import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import store from '../../store/index';
import SpinnerLoader from '../../components/common/SpinnerLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import 'react-data-table-component-extensions/dist/index.css';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import Header from '../../components/admin/common/Header';
import Footer from '../../components/common/Footer';
import { Link } from "react-router-dom";
import arrow_back from '../../assets/icons/arrow-back.svg';
import { Modal } from 'react-bootstrap';
import { getImageUrl } from '../../utils/getImageUrl';
import {
  BANNER_IMAGE_ACCEPT,
  BANNER_IMAGE_HINT,
  createBannerImageSchema,
  handleBannerImageChange,
} from '../../utils/bannerImageValidation';
import { EmailTemplateManagement, LegalNoticesManagement } from './EmailTemplateManagement';
import '../../assets/css/admin-cms.css';
import {
  FaChevronDown,
  FaChevronUp,
  FaEdit,
  FaTrash,
  FaPlus,
  FaEye,
  FaPaperPlane,
  FaArrowLeft,
  FaUpload,
  FaGripVertical,
  FaToggleOn,
  FaToggleOff,
  FaSave,
  FaTimes,
  FaHome,
  FaEnvelope,
  FaGavel,
  FaBullhorn,
  FaImage,
  FaCog,
  FaSearch
} from 'react-icons/fa';

const AdminCMSInterface = () => {
  const history = useHistory();
  const authInfo = store.getState().auth.authInfo;
  const authInfoString = JSON.parse(localStorage.getItem("authInfo"));

  const [activeTab, setActiveTab] = useState('banners');
  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState({
    add: '',
    edit: '',
    delete: ''
  });

  // Modal states
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Banner Management State
  const [banners, setBanners] = useState([]);
  const [selectedBanners, setSelectedBanners] = useState([]);

  // Footer Links State
  const [footerSections, setFooterSections] = useState([]);
  const [showFooterModal, setShowFooterModal] = useState(false);
const [editingFooterSection, setEditingFooterSection] = useState(null);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [editingLink, setEditingLink] = useState(null);
  const [currentSectionForLink, setCurrentSectionForLink] = useState(null);

  // Email Templates State
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [selectedTemplates, setSelectedTemplates] = useState([]);

  // Legal Notices State
  const [legalNotices, setLegalNotices] = useState([]);
  const [selectedNotices, setSelectedNotices] = useState([]);

  const [showImageModal, setShowImageModal] = useState(false);
const [selectedImage, setSelectedImage] = useState(null);

const [editingBanner, setEditingBanner] = useState(null);
const [showEditBannerModal, setShowEditBannerModal] = useState(false);

const footerSectionValidationSchema = Yup.object({
  name: Yup.string()
    .required('Section name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name cannot exceed 100 characters'),
  description: Yup.string()
    .max(500, 'Description cannot exceed 500 characters'),
  order: Yup.number()
    .required('Order is required')
    .min(1, 'Order must be at least 1')
    .integer('Order must be a whole number'),
  displayOnPages: Yup.array()
    .min(1, 'At least one page must be selected')
});


// Create/Update Footer Section
const handleSaveFooterSection = async (values, { setSubmitting, resetForm }) => {
  try {
    console.log('Original values:', values);

    const dataToSend = {
      name: values.name,
      description: values.description || '',
      order: parseInt(values.order),
      displayOnPages: values.displayOnPages,
      cssClass: values.cssClass || '',
      htmlId: values.htmlId || '',
      active: values.active,
      isSocialMedia: values.isSocialMedia || false,
      createdBy: editingFooterSection ? undefined : authInfoString.id,
      updatedBy: editingFooterSection ? authInfoString.id : undefined
    };

    console.log('Data to send:', dataToSend);

    const endpoint = editingFooterSection
      ? `admin/footer-sections/update/${editingFooterSection.id}`
      : 'admin/footer-sections/create';

    const method = editingFooterSection ? 'put' : 'post';

    const res = await axios[method](endpoint, dataToSend, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authInfoString.token}`,
      },
    });

    if (res.data.status) {
      toast.success(`Section ${editingFooterSection ? 'updated' : 'created'} successfully!`);
      setShowFooterModal(false);
      setEditingFooterSection(null);
      resetForm();
      loadCMSData();
    }
  } catch (error) {
    console.error('API Error:', error.response?.data);
    toast.error(error.response?.data?.message || 'Error saving section');
  } finally {
    setSubmitting(false);
  }
};
// Delete Footer Section
const handleDeleteFooterSection = async (sectionId) => {
  try {
    await axios.delete(`admin/footer-sections/delete/${sectionId}`, {
      headers: {
        Authorization: `Bearer ${authInfoString.token}`,
      },
    });

    toast.success('Footer section deleted successfully!');
    loadCMSData();
  } catch (error) {
    toast.error(error.response?.data?.message || 'Error deleting section');
  }
};

// Open Add Link Modal
const openAddLinkModal = (section) => {
  setCurrentSectionForLink(section);
  setEditingLink(null);
  setShowLinkModal(true);
};

// Open Edit Link Modal
const openEditLinkModal = (section, link) => {
  setCurrentSectionForLink(section);
  setEditingLink(link);
  setShowLinkModal(true);
};

// Add Link to Footer Section
const handleAddFooterLink = async (sectionId, linkData) => {
  try {
    const res = await axios.post(`admin/footer-sections/add-link/${sectionId}`, linkData, {
      headers: {
        Authorization: `Bearer ${authInfoString.token}`,
      },
    });

    if (res.data.status) {
      toast.success('Link added successfully!');
      loadCMSData();
    }
  } catch (error) {
    toast.error(error.response?.data?.message || 'Error adding link');
  }
};

// Remove Link from Footer Section
const handleRemoveFooterLink = async (sectionId, linkId) => {
  if (!linkId || !sectionId) {
    toast.error('Missing section or link ID');
    return;
  }

  try {
    await axios.delete(
      `/admin/footer-sections/remove-link/${sectionId}/${linkId}`,
      {
        headers: {
          Authorization: `Bearer ${authInfoString.token}`,
        },
      }
    );

    toast.success('Link removed successfully!');
    loadCMSData();
  } catch (error) {
    console.error('Remove Footer Link Error:', error);
    toast.error(error.response?.data?.message || 'Error removing link');
  }
};

const handleEditFooterLink = async (sectionId, linkId, updateData) => {
  try {
    await axios.put(
      `/admin/footer-sections/edit-link/${sectionId}/${linkId}`,
      updateData,
      {
        headers: {
          Authorization: `Bearer ${authInfoString.token}`,
        },
      }
    );

    toast.success('Link updated successfully!');
    loadCMSData();
  } catch (error) {
    console.error(error);
    toast.error(error.response?.data?.message || 'Error updating link');
  }
};


  // Validation Schemas
  const bannerValidationSchema = Yup.object().shape({
    title: Yup.string()
        .min(3, 'Title must be at least 3 characters')
        .max(200, 'Title cannot exceed 200 characters'),

    subtitle: Yup.string()
        .min(5, 'Subtitle must be at least 5 characters')
        .max(300, 'Subtitle cannot exceed 300 characters'),

    ctaText: Yup.string()
        .max(50, 'CTA text cannot exceed 50 characters'),

    ctaLink: Yup.string()
        .url('Please enter a valid URL')
        .required('CTA link is required'),
    priority: Yup.number()
        .min(1, 'Priority must be at least 1')
        .max(10, 'Priority cannot exceed 10')
        .required('Priority is required'),
    location: Yup.string()
        .oneOf([
            'homepage', 'dashboard', 'product_listing', 'product_detail',
            'checkout', 'profile', 'about', 'contact', 'blog', 'all_pages'
        ])
        .required('Location is required'),
    section: Yup.string()
        .required('Section is required'),
    targetAudience: Yup.string()
        .oneOf(['all', 'new_users', 'existing_users', 'premium_users', 'guests'])
        .required('Target audience is required'),
    startDate: Yup.date().nullable(),
    endDate: Yup.date()
        .nullable()
        .when('startDate', (startDate, schema) => {
            return startDate ? schema.min(startDate, 'End date must be after start date') : schema;
        }),
    active: Yup.boolean(),
    image: createBannerImageSchema({ required: true }),
});

  const emailTemplateValidationSchema = Yup.object({
    name: Yup.string()
      .required('Template name is required')
      .min(3, 'Name must be at least 3 characters'),
    subject: Yup.string()
      .required('Subject is required')
      .min(5, 'Subject must be at least 5 characters'),
    body: Yup.string()
      .required('Email body is required')
      .min(10, 'Body must be at least 10 characters'),
    tag: Yup.string()
      .required('Tag is required')
  });

  const legalNoticeValidationSchema = Yup.object({
    title: Yup.string()
      .required('Notice title is required')
      .min(3, 'Title must be at least 3 characters'),
    content: Yup.string()
      .required('Notice content is required')
      .min(10, 'Content must be at least 10 characters'),
    location: Yup.string()
      .required('Location is required'),
    type: Yup.string()
      .required('Notice type is required')
  });

  // Component Mount
  useEffect(() => {
    getCMSPermissions();
    loadCMSData();
  }, []);

  // Get CMS Permissions
  const getCMSPermissions = async () => {
    const admin_Id = authInfoString?.id;
    if (!admin_Id) return;

    setLoading(true);
    try {
      const res = await axios.get(`admin/permissions/${admin_Id}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          Authorization: `Bearer ${authInfoString.token}`,
        },
      });

      if (res.data.status === true && res.data.data) {
        setPermissions(res.data.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error fetching permissions');
      console.error("Error fetching permissions: ", error);
    } finally {
      setLoading(false);
    }
  };

  // Load CMS Data
 const loadCMSData = async () => {
  setLoading(true);
  try {
    // Load banners
    const bannersRes = await axios.get('admin/new-banners', { // Changed from 'admin/new-banners'
      headers: {
        Authorization: `Bearer ${authInfoString.token}`,
      },
    });
    setBanners(bannersRes.data.data || []);

    // Load footer sections
    const footerRes = await axios.get('admin/footer-sections', {
      headers: {
        Authorization: `Bearer ${authInfoString.token}`,
      },
    });
    // Check if the response structure matches your API
    console.log('Footer API response:', footerRes.data); // Debug log
    setFooterSections(footerRes.data.data || footerRes.data || []);

    // Load email templates
    const templatesRes = await axios.get('admin/email-templates', {
      headers: {
        Authorization: `Bearer ${authInfoString.token}`,
      },
    });
    setEmailTemplates(templatesRes.data.data || []);

    // Load legal notices
    const noticesRes = await axios.get('admin/legal-notices', {
      headers: {
        Authorization: `Bearer ${authInfoString.token}`,
      },
    });
    setLegalNotices(noticesRes.data.data || []);

  } catch (error) {
    console.error("Error loading CMS data: ", error);
    // Set fallback data
    setFooterSections([
      {
        id: 1,
        name: 'Quick Links',
        description: 'Navigation links',
        order: 1,
        displayOnPages: ['all'],
        active: true,
        links: []
      }
    ]);
  } finally {
    setLoading(false);
  }
};
  // Create Banner
    const handleCreateBanner = async (values, { setSubmitting, resetForm }) => {
      try {
        const formData = new FormData();

        // Convert startTime to UTC ISO format
        const utcStartTime = new Date(values.startDate).toISOString();

        const dataToSend = {
          ...values,
          startTime: utcStartTime, // override with UTC version
          createdBy: authInfoString.id
        };

        // Append all form data
        Object.keys(dataToSend).forEach(key => {
          if (key === 'image' && dataToSend[key]) {
            formData.append(key, dataToSend[key]);
          } else if (key !== 'image') {
            formData.append(key, dataToSend[key]);
          }
        });

        const res = await axios.post('admin/new-banners/create', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authInfoString.token}`,
          },
        });

        if (res.data.status) {
          toast.success('Banner created successfully!');
          resetForm();
          loadCMSData();
        }
      } catch (error) {
        console.log(error);

        toast.error(error?.response?.data?.message || 'Error creating banner here');
      } finally {
        setSubmitting(false);
      }
    };

  // Delete Item
    const handleDeleteItem = async () => {
        if (!selectedItem) return;

        try {
            let endpoint = '';
            switch (activeTab) {
            case 'banners':
                endpoint = `admin/new-banners/delete/${selectedItem.id}`;
                break;
            case 'emails':
                endpoint = `admin/email-templates/delete/${selectedItem.id}`;
                break;
            case 'legal':
                endpoint = `admin/legal-notices/delete/${selectedItem.id}`;
                break;
            case 'footer':
                endpoint = `admin/footer-sections/delete/${selectedItem.id}`;
                break;
            default:
                return;
            }

            await axios.delete(endpoint, {
            headers: {
                Authorization: `Bearer ${authInfoString.token}`,
            },
            });

            toast.success('Item deleted successfully!');
            setShowDeleteModal(false);
            setSelectedItem(null);
            loadCMSData();
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error deleting item');
        }
    };

    const handleToggleBannerStatus = async (banner) => {
        try {
            await axios.patch(`admin/new-banners/toggle/${banner.id}`, {
            updatedBy: authInfoString.id
            }, {
            headers: {
                Authorization: `Bearer ${authInfoString.token}`,
            },
            });

            toast.success('Banner status updated!');
            loadCMSData();
        } catch (error) {
            toast.error(error.response?.data?.message || 'Error updating status');
        }
    };

  // Banner Columns for DataTable
    const bannerColumns = [
    {
      name: 'BANNER',
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center gap-2 admin-cms-banner-cell">
          <div className="banner-thumb">
            <div
              className="bg-light rounded p-2 position-relative banner-image-container"
              style={{
                width: '50px',
                height: '50px',
                cursor: row.image?.url ? 'pointer' : 'default'
              }}
              onClick={() => {
                if (row.image?.url) {
                  setSelectedImage({
                    url: getImageUrl(row.image.url),
                    title: row.title,
                    subtitle: row.subtitle
                  });
                  setShowImageModal(true);
                }
              }}
            >
              {row.image?.url ? (
                <>
                  <img
                    src={getImageUrl(row.image.url)}
                    alt={row.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '4px'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div
                    style={{ display: 'none' }}
                    className="d-flex align-items-center justify-content-center h-100"
                  >
                    <FaImage className="text-muted" size={20} />
                  </div>
                  <div className="banner-image-overlay">
                    <FaEye className="text-white" size={16} />
                  </div>
                </>
              ) : (
                <FaImage className="text-muted" size={20} />
              )}
            </div>
          </div>
          <div className="admin-cms-banner-text">
            <div className="fw-bold text-truncate" title={row.title}>
              {row.title}
            </div>
            <small className="text-muted text-truncate d-block" title={row.subtitle}>
              {row.subtitle}
            </small>
          </div>
        </div>
      ),
    },
    {
      name: 'PRIORITY',
      selector: (row) => row.priority,
      sortable: true,
      cell: (row) => (
        <span className="badge bg-primary">{row.priority}</span>
      ),
    },
    {
      name: 'STATUS',
      selector: (row) => row.active,
      sortable: true,
      cell: (row) => (
        <button
          onClick={() => handleToggleBannerStatus(row)}
          className="btn btn-sm p-0 border-0 d-flex align-items-center"
          disabled={!permissions.edit}
        >
          {row.active ? (
            <FaToggleOn className="text-success me-1" size={20} />
          ) : (
            <FaToggleOff className="text-muted me-1" size={20} />
          )}
          <span
            className={row.active ? 'text-success' : 'text-muted'}
            style={{ whiteSpace: "nowrap" }}
          >
            {row.active ? 'Active' : 'Inactive'}
          </span>
        </button>
      ),
    },
    {
      name: 'ACTIONS',
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-outline-primary"
            disabled={!permissions.edit}
            onClick={() => {
              setEditingBanner(row);
              setShowEditBannerModal(true);
            }}
            title="Edit Banner"
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            disabled={!permissions.delete}
            onClick={() => {
              setSelectedItem(row);
              setShowDeleteModal(true);
            }}
            title="Delete Banner"
          >
            <FaTrash />
          </button>
        </div>
      ),
    },
  ];


const handleUpdateBanner = async (values, { setSubmitting, resetForm }) => {
    try {
        const formData = new FormData();

        // Add updatedBy field and all form data
        const dataToSend = {
            ...values,
            updatedBy: authInfoString.id
        };

        // Append all form data
        Object.keys(dataToSend).forEach(key => {
            if (key === 'image' && dataToSend[key]) {
                formData.append(key, dataToSend[key]);
            } else if (key !== 'image') {
                formData.append(key, dataToSend[key]);
            }
        });

        // Make API call to update banner
        const res = await axios.put(`admin/new-banners/update/${editingBanner._id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${authInfoString.token}`,
            },
        });

        if (res.data.status) {
            toast.success('Banner updated successfully!');
            setShowEditBannerModal(false);
            setEditingBanner(null);
            loadCMSData(); // Refresh the banner list
        }
    } catch (error) {
        toast.error(error.response?.data?.message || 'Error updating banner');
        console.error('Update error:', error);
    } finally {
        setSubmitting(false);
    }
};

const EditBannerModal = () => (
  <Modal
    show={showEditBannerModal}
    onHide={() => {
      setShowEditBannerModal(false);
      setEditingBanner(null);
    }}
    size="lg"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title>
        <FaEdit className="me-2" />
        Edit Banner
      </Modal.Title>
    </Modal.Header>

    {editingBanner && (
      <Formik
        initialValues={{
          title: editingBanner.title || '',
          subtitle: editingBanner.subtitle || '',
          ctaText: editingBanner.ctaText || '',
          ctaLink: editingBanner.ctaLink || '',
          priority: editingBanner.priority || 1,
          active: editingBanner.active !== undefined ? editingBanner.active : true,
          targetAudience: editingBanner.targetAudience || 'all',
          location: editingBanner.location || editingBanner.displayLocation || 'homepage', // Support both old and new field names
          section: editingBanner.section || 'hero',
          startDate: editingBanner.startDate ?
            new Date(editingBanner.startDate).toISOString().split('T')[0] : '',
          endDate: editingBanner.endDate ?
            new Date(editingBanner.endDate).toISOString().split('T')[0] : '',
          image: null // For new image upload
        }}
        validationSchema={bannerEditValidationSchema}
        onSubmit={handleUpdateBanner}
        enableReinitialize={true}
        validateOnChange
        validateOnBlur
      >
        {({ isSubmitting, setFieldValue, setFieldTouched, isValid, errors, touched, values }) => (
          <Form>
            <Modal.Body>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="title">Banner Title</label>
                  <Field
                    name="title"
                    type="text"
                    className="form-control"
                    placeholder="Enter banner title"
                  />
                  <ErrorMessage name="title" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="subtitle">Banner Subtitle</label>
                  <Field
                    name="subtitle"
                    type="text"
                    className="form-control"
                    placeholder="Enter banner subtitle"
                  />
                  <ErrorMessage name="subtitle" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-4 mb-3">
                  <label htmlFor="ctaText">CTA Text</label>
                  <Field
                    name="ctaText"
                    type="text"
                    className="form-control"
                    placeholder="Button text"
                  />
                  <ErrorMessage name="ctaText" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-4 mb-3">
                  <label htmlFor="ctaLink">CTA Link *</label>
                  <Field
                    name="ctaLink"
                    type="url"
                    className="form-control"
                    placeholder="https://example.com"
                  />
                  <ErrorMessage name="ctaLink" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-4 mb-3">
                  <label htmlFor="priority">Priority *</label>
                  <Field name="priority" as="select" className="form-control">
                    {[1,2,3,4,5,6,7,8,9,10].map(num => (
                      <option key={num} value={num}>Priority {num}</option>
                    ))}
                  </Field>
                  <ErrorMessage name="priority" component="div" className="text-danger small mt-1" />
                </div>

                {/* Updated Location Selection */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="location">Page Location *</label>
                  <Field
                    name="location"
                    as="select"
                    className="form-control"
                    onChange={(e) => {
                      setFieldValue('location', e.target.value);
                      // Reset section when location changes
                      const defaultSections = {
                        homepage: 'hero',
                        dashboard: 'top',
                        product_listing: 'top',
                        product_detail: 'above_product',
                        checkout: 'top',
                        profile: 'top',
                        about: 'top',
                        contact: 'top',
                        blog: 'top',
                        all_pages: 'header'
                      };
                      setFieldValue('section', defaultSections[e.target.value] || 'hero');
                    }}
                  >
                    <option value="homepage">Homepage</option>
                    <option value="dashboard">Dashboard</option>
                    <option value="product_listing">Product Listing</option>
                    <option value="product_detail">Product Detail</option>
                    <option value="checkout">Checkout</option>
                    <option value="profile">User Profile</option>
                    <option value="about">About Us</option>
                    <option value="contact">Contact Us</option>
                    <option value="blog">Blog</option>
                    <option value="all_pages">All Pages</option>
                  </Field>
                  <ErrorMessage name="location" component="div" className="text-danger small mt-1" />
                </div>

                {/* Updated Section Selection */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="section">Page Section *</label>
                  <Field name="section" as="select" className="form-control">
                    {/* Dynamic sections based on location */}
                    {values.location === 'homepage' && (
                      <>
                        <option value="hero">Hero Section</option>
                        <option value="featured">Featured Section</option>
                        <option value="middle">Middle Section</option>
                        <option value="bottom">Bottom Section</option>
                        <option value="sidebar">Sidebar</option>
                      </>
                    )}
                    {values.location === 'dashboard' && (
                      <>
                        <option value="top">Top Banner</option>
                        <option value="sidebar">Sidebar</option>
                        <option value="widget">Widget Area</option>
                        <option value="notification">Notification Area</option>
                      </>
                    )}
                    {values.location === 'product_listing' && (
                      <>
                        <option value="top">Top of Listing</option>
                        <option value="sidebar">Sidebar</option>
                        <option value="between_products">Between Products</option>
                        <option value="bottom">Bottom of Listing</option>
                      </>
                    )}
                    {values.location === 'product_detail' && (
                      <>
                        <option value="above_product">Above Product</option>
                        <option value="below_product">Below Product</option>
                        <option value="sidebar">Sidebar</option>
                        <option value="related_products">Related Products Area</option>
                      </>
                    )}
                    {values.location === 'checkout' && (
                      <>
                        <option value="top">Top of Checkout</option>
                        <option value="sidebar">Sidebar</option>
                        <option value="payment_section">Payment Section</option>
                      </>
                    )}
                    {(values.location === 'profile' || values.location === 'about' ||
                      values.location === 'contact' || values.location === 'blog') && (
                      <>
                        <option value="top">Top Section</option>
                        <option value="sidebar">Sidebar</option>
                        <option value="bottom">Bottom Section</option>
                      </>
                    )}
                    {values.location === 'all_pages' && (
                      <>
                        <option value="header">Header</option>
                        <option value="footer">Footer</option>
                        <option value="floating">Floating Banner</option>
                        <option value="popup">Popup Modal</option>
                      </>
                    )}
                  </Field>
                  <ErrorMessage name="section" component="div" className="text-danger small mt-1" />
                  <small className="text-muted">Choose where exactly on the page this banner should appear</small>
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="targetAudience">Target Audience *</label>
                  <Field name="targetAudience" as="select" className="form-control">
                    <option value="all">All Users</option>
                    <option value="new_users">New Users</option>
                    <option value="existing_users">Existing Users</option>
                    <option value="premium_users">Premium Users</option>
                    <option value="guests">Guest Users</option>
                  </Field>
                  <ErrorMessage name="targetAudience" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-3 mb-3">
                  <label htmlFor="startDate">Start Date</label>
                  <Field
                    name="startDate"
                    type="date"
                    className="form-control"
                  />
                  <ErrorMessage name="startDate" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-3 mb-3">
                  <label htmlFor="endDate">End Date</label>
                  <Field
                    name="endDate"
                    type="date"
                    className="form-control"
                  />
                  <ErrorMessage name="endDate" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-6 mb-3">
                  <label htmlFor="image">Banner Image</label>
                  <input
                    type="file"
                    className={`form-control${errors.image && touched.image ? ' is-invalid' : ''}`}
                    accept={BANNER_IMAGE_ACCEPT}
                    onChange={(event) =>
                      handleBannerImageChange(event, setFieldValue, setFieldTouched, {
                        required: false,
                        onValidationError: (message) => toast.warning(message),
                      })
                    }
                  />
                  <small className="text-muted d-block">
                    Leave empty to keep current image • {BANNER_IMAGE_HINT}
                  </small>
                  <ErrorMessage name="image" component="div" className="text-danger small mt-1" />
                </div>

                <div className="col-md-6 d-flex align-items-center mb-3 mt-4">
                  <div className="form-check">
                    <Field
                      name="active"
                      type="checkbox"
                      className="form-check-input"
                      id="edit-banner-active"
                    />
                    <label className="form-check-label ms-2" htmlFor="edit-banner-active">
                      Active Banner
                    </label>
                  </div>
                </div>

                {/* Current Image Preview */}
                {editingBanner.image?.url && (
                  <div className="col-12 mb-3">
                    <label className="form-label">Current Image</label>
                    <div className="current-image-preview">
                      <img
                        src={getImageUrl(editingBanner.image.url)}
                        alt={editingBanner.title}
                        style={{
                          maxWidth: '200px',
                          maxHeight: '100px',
                          objectFit: 'cover',
                          borderRadius: '8px',
                          border: '2px solid #e9ecef'
                        }}
                      />
                      <small className="d-block text-muted mt-1">
                        Current banner image • Upload new image to replace
                      </small>
                    </div>
                  </div>
                )}
              </div>
            </Modal.Body>

            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setShowEditBannerModal(false);
                  setEditingBanner(null);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn custom_btn btn_yellow"
                disabled={isSubmitting || !isValid}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Updating...
                  </>
                ) : (
                  <>
                    <FaSave className="me-1" />
                    Update Banner
                  </>
                )}
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    )}
  </Modal>
);

// 5. Update banner validation schema (make image optional for edit)
const bannerEditValidationSchema = Yup.object({
  title: Yup.string()
    .transform((value) => (value === '' ? undefined : value))
    .notRequired()
    .max(200, 'Title cannot exceed 200 characters')
    .test(
      'title-min-if-filled',
      'Title must be at least 3 characters',
      (value) => !value || value.length >= 3
    ),
  subtitle: Yup.string()
    .transform((value) => (value === '' ? undefined : value))
    .notRequired()
    .max(300, 'Subtitle cannot exceed 300 characters')
    .test(
      'subtitle-min-if-filled',
      'Subtitle must be at least 5 characters',
      (value) => !value || value.length >= 5
    ),
  ctaText: Yup.string()
    .transform((value) => (value === '' ? undefined : value))
    .notRequired()
    .max(50, 'CTA text cannot exceed 50 characters'),
  ctaLink: Yup.string()
    .url('Must be a valid URL')
    .required('CTA link is required'),
  priority: Yup.number()
    .required('Priority is required')
    .min(1, 'Priority must be at least 1')
    .max(10, 'Priority cannot exceed 10'),
  startDate: Yup.date()
    .nullable(),
  endDate: Yup.date()
    .nullable()
    .min(Yup.ref('startDate'), 'End date must be after start date'),
  image: createBannerImageSchema({ required: false }),
});


    const ImageModal = () => (
      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FaImage className="me-2" />
            Banner Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-4">
          {selectedImage && (
            <>
              <div className="mb-3">
                <h5 className="fw-bold">{selectedImage.title}</h5>
                {selectedImage.subtitle && (
                  <p className="text-muted">{selectedImage.subtitle}</p>
                )}
              </div>
              <div className="banner-image-preview">
                <img
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '70vh',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                  }}
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTgiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZSBub3QgZm91bmQ8L3RleHQ+PC9zdmc+';
                  }}
                />
              </div>
              <div className="mt-3">
                <small className="text-muted">Click outside or press ESC to close</small>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowImageModal(false)}
          >
            Close
          </button>
          {selectedImage?.url && (
            <a
              href={selectedImage.url}
              target="_blank"
              rel="noopener noreferrer"
              className="btn custom_btn btn_yellow"
            >
              <FaEye className="me-1" />
              View Full Size
            </a>
          )}
        </Modal.Footer>
      </Modal>
    );

  // Tab Navigation Component
  const TabNavigation = () => (
    <div className="admin-cms-header-bar">
      <div
        className="admin-cms-header-inner"
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) auto',
          alignItems: 'center',
          gap: '1rem',
          width: '100%',
        }}
      >
        <h2>Content Management System</h2>
        <div className="admin-cms-tab-buttons">
          {[
            { id: 'banners', label: 'Homepage Banners', icon: FaHome, count: banners.length },
            { id: 'footer', label: 'Footer Links', icon: FaBullhorn, count: footerSections.length },
            { id: 'emails', label: 'Email Templates', icon: FaEnvelope, count: emailTemplates.length },
            { id: 'legal', label: 'Legal Notices', icon: FaGavel, count: legalNotices.length }
          ].map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`btn admin-cms-tab-btn d-inline-flex align-items-center ${
                activeTab === tab.id ? 'admin-cms-tab-btn--active' : ''
              }`}
            >
              <tab.icon className="me-2" />
              {tab.label}
              <span className="badge ms-2">{tab.count}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  // Banner Management Component
   const BannerManagement = () => (
    <div className="row">
        <div className="col-12">
            <div className="createpost bg-white rounded-3 mt-2 addPost_left_container">
            <div className="dash_inner_wrap pb-2">
                <div className="dash_title d-flex align-items-center">
                <FaImage className="me-2" />
                Create New Banner
                </div>
            </div>

            <div className="cp_body">
                <Formik
                initialValues={{
                    title: '',
                    subtitle: '',
                    ctaText: '',
                    ctaLink: '',
                    priority: 1,
                    active: true,
                    image: null,
                    location: 'homepage',
                    section: 'hero',
                    startDate: '',
                    endDate: '',
                    targetAudience: 'all'
                }}
                validationSchema={bannerValidationSchema}
                onSubmit={handleCreateBanner}
                validateOnChange
                validateOnBlur
                >
                {({ isSubmitting, setFieldValue, setFieldTouched, isValid, errors, touched, values }) => (
                    <Form>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                        <label htmlFor="title">Banner Title </label>
                        <Field name="title" type="text" className="form-control" placeholder="Enter banner title" />
                        <ErrorMessage name="title" component="div" className="text-danger small mt-1" />
                        </div>

                        <div className="col-md-6 mb-3">
                        <label htmlFor="subtitle">Banner Subtitle </label>
                        <Field name="subtitle" type="text" className="form-control" placeholder="Enter banner subtitle" />
                        <ErrorMessage name="subtitle" component="div" className="text-danger small mt-1" />
                        </div>

                        <div className="col-md-4 mb-3">
                        <label htmlFor="ctaText">CTA Text</label>
                        <Field name="ctaText" type="text" className="form-control" placeholder="Button text" />
                        <ErrorMessage name="ctaText" component="div" className="text-danger small mt-1" />
                        </div>

                        <div className="col-md-4 mb-3">
                        <label htmlFor="ctaLink">CTA Link *</label>
                        <Field name="ctaLink" type="url" className="form-control" placeholder="https://example.com" />
                        <ErrorMessage name="ctaLink" component="div" className="text-danger small mt-1" />
                        </div>

                        <div className="col-md-4 mb-3">
                        <label htmlFor="priority">Priority *</label>
                        <Field name="priority" as="select" className="form-control">
                            {[1,2,3,4,5,6,7,8,9,10].map(num => (
                            <option key={num} value={num}>Priority {num}</option>
                            ))}
                        </Field>
                        <ErrorMessage name="priority" component="div" className="text-danger small mt-1" />
                        </div>

                        {/* Location Selection */}
                        <div className="col-md-6 mb-3">
                        <label htmlFor="location">Page Location *</label>
                        <Field name="location" as="select" className="form-control">
                            <option value="homepage">Homepage</option>
                            <option value="dashboard">Dashboard</option>
                            <option value="product_listing">Product Listing</option>
                            <option value="product_detail">Product Detail</option>
                            <option value="checkout">Checkout</option>
                            <option value="profile">User Profile</option>
                            <option value="about">About Us</option>
                            <option value="contact">Contact Us</option>
                            <option value="blog">Blog</option>
                            <option value="all_pages">All Pages</option>
                        </Field>
                        <ErrorMessage name="location" component="div" className="text-danger small mt-1" />
                        </div>

                        {/* Section Selection */}
                        <div className="col-md-6 mb-3">
                        <label htmlFor="section">Page Section *</label>
                        <Field name="section" as="select" className="form-control">
                            {/* Dynamic sections based on location */}
                            {values.location === 'homepage' && (
                                <>
                                <option value="hero">Hero Section</option>
                                <option value="featured">Featured Section</option>
                                <option value="middle">Middle Section</option>
                                <option value="bottom">Bottom Section</option>
                                <option value="sidebar">Sidebar</option>
                                </>
                            )}
                            {values.location === 'dashboard' && (
                                <>
                                <option value="top">Top Banner</option>
                                <option value="sidebar">Sidebar</option>
                                <option value="widget">Widget Area</option>
                                <option value="notification">Notification Area</option>
                                </>
                            )}
                            {values.location === 'product_listing' && (
                                <>
                                <option value="top">Top of Listing</option>
                                <option value="sidebar">Sidebar</option>
                                <option value="between_products">Between Products</option>
                                <option value="bottom">Bottom of Listing</option>
                                </>
                            )}
                            {values.location === 'product_detail' && (
                                <>
                                <option value="above_product">Above Product</option>
                                <option value="below_product">Below Product</option>
                                <option value="sidebar">Sidebar</option>
                                <option value="related_products">Related Products Area</option>
                                </>
                            )}
                            {values.location === 'checkout' && (
                                <>
                                <option value="top">Top of Checkout</option>
                                <option value="sidebar">Sidebar</option>
                                <option value="payment_section">Payment Section</option>
                                </>
                            )}
                            {(values.location === 'profile' || values.location === 'about' || values.location === 'contact' || values.location === 'blog') && (
                                <>
                                <option value="top">Top Section</option>
                                <option value="sidebar">Sidebar</option>
                                <option value="bottom">Bottom Section</option>
                                </>
                            )}
                            {values.location === 'all_pages' && (
                                <>
                                <option value="header">Header</option>
                                <option value="footer">Footer</option>
                                <option value="floating">Floating Banner</option>
                                <option value="popup">Popup Modal</option>
                                </>
                            )}
                        </Field>
                        <ErrorMessage name="section" component="div" className="text-danger small mt-1" />
                        <small className="text-muted">Choose where exactly on the page this banner should appear</small>
                        </div>

                        {/* Target Audience */}
                        <div className="col-md-6 mb-3">
                        <label htmlFor="targetAudience">Target Audience *</label>
                        <Field name="targetAudience" as="select" className="form-control">
                            <option value="all">All Users</option>
                            <option value="new_users">New Users</option>
                            <option value="existing_users">Existing Users</option>
                            <option value="premium_users">Premium Users</option>
                            <option value="guests">Guest Users</option>
                        </Field>
                        <ErrorMessage name="targetAudience" component="div" className="text-danger small mt-1" />
                        </div>

                        {/* Date Range */}
                        <div className="col-md-3 mb-3">
                        <label htmlFor="startDate">Start Date</label>
                        <Field name="startDate" type="datetime-local" className="form-control" />
                        <ErrorMessage name="startDate" component="div" className="text-danger small mt-1" />
                        </div>

                        <div className="col-md-3 mb-3">
                        <label htmlFor="endDate">End Date</label>
                        <Field name="endDate" type="datetime-local" className="form-control" />
                        <ErrorMessage name="endDate" component="div" className="text-danger small mt-1" />
                        </div>

                        <div className="col-md-6 mb-3">
                        <label htmlFor="image">Banner Image *</label>
                        <input
                            type="file"
                            className={`form-control${errors.image && touched.image ? ' is-invalid' : ''}`}
                            accept={BANNER_IMAGE_ACCEPT}
                            onChange={(event) =>
                              handleBannerImageChange(event, setFieldValue, setFieldTouched, {
                                required: true,
                                onValidationError: (message) => toast.warning(message),
                              })
                            }
                        />
                        <small className="text-muted d-block">{BANNER_IMAGE_HINT}</small>
                        <ErrorMessage name="image" component="div" className="text-danger small mt-1" />
                        </div>

                        <div className="col-md-6 d-flex align-items-center mb-3 mt-4">
                        <div className="form-check">
                            <Field
                            name="active"
                            type="checkbox"
                            className="form-check-input"
                            id="banner-active"
                            />
                            <label className="form-check-label ms-2" htmlFor="banner-active">
                            Active Banner
                            </label>
                        </div>
                        </div>

                        <div className="col-12 text-end">
                        <button
                            type="submit"
                            className="btn custom_btn btn_yellow_bordered"
                            disabled={!permissions.add || isSubmitting || !isValid}
                        >
                            {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Creating...
                            </>
                            ) : (
                            <>
                                <FaPlus className="me-2" />
                                Create Banner
                            </>
                            )}
                        </button>
                        </div>
                    </div>
                    </Form>
                )}
                </Formik>
            </div>
            </div>

            {/* Banner list */}
            <div className="createpost bg-white rounded-3 mt-4 addPost_left_container">
              <div className="dash_inner_wrap pb-2">
                <div className="dash_title">Banner List</div>
              </div>

              <div className="cp_body pt-0">
              <div className="admin-cms-table-wrap">
                <DataTableExtensions
                  columns={bannerColumns}
                  data={banners}
                  exportHeaders={true}
                >
                  <DataTable
                    pagination
                    noHeader
                    highlightOnHover
                    defaultSortField="priority"
                    defaultSortAsc={true}
                    selectedRows={selectedBanners}
                    onSelectedRowsChange={setSelectedBanners}
                    selectableRows
                    responsive
                  />
                </DataTableExtensions>
              </div>
              </div>
            </div>
        </div>
    </div>
);

  // Footer Links Management Component
  const FooterManagement = () => (
  <div className="row">
      <div className="col-lg-12">
        <div className="createpost bg-white rounded-3 mt-2 addPost_left_container">
          <div className="dash_inner_wrap pb-2">
            <div className="dash_header_row">
              <div className="dash_title">Footer Link Management</div>
              <div>
                <button
                  className="btn custom_btn btn_yellow"
                  disabled={!permissions.add}
                  onClick={() => setShowFooterModal(true)}
                >
                  <FaPlus className="me-2" />
                  Add Section
                </button>
              </div>
            </div>
          </div>

          <div className="cp_body">
            <div className="row">
              {footerSections.map((section) => (
                <div key={section.id} className="col-lg-4 col-md-6 mb-4">
                  <div className="card h-100 admin-cms-footer-card">
                    <div className="card-header">
                      <h6 className="mb-0">{section.name}</h6>
                      <div className="card-header-actions">
                        <button
                          className="btn btn-sm custom_btn btn_yellow_bordered"
                          onClick={() => openAddLinkModal(section)}
                        >
                          <FaPlus className="me-1" />
                          Add Link
                        </button>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => {
                            setEditingFooterSection(section);
                            setShowFooterModal(true);
                          }}
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => {
                            if (window.confirm(`Are you sure you want to delete section "${section.name}"?`)) {
                              handleDeleteFooterSection(section.id);
                            }
                          }}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      {section.links?.map((link) => (
                        <div key={link.id} className="border-bottom p-3">
                          <div className="d-flex justify-content-between align-items-start gap-2">
                            <div className="d-flex align-items-start min-w-0 flex-grow-1">
                              <FaGripVertical className="text-muted me-2 mt-1 flex-shrink-0" />
                              <div className="min-w-0">
                                <div className="fw-bold small text-truncate">
                                  {link.icon && (
                                    <span className="badge bg-info me-2">
                                      <i className={`fab fa-${link.icon}`}></i> {link.icon}
                                    </span>
                                  )}
                                  {link.text}
                                </div>
                                <small className="text-muted text-truncate d-block">{link.url}</small>
                              </div>
                            </div>
                            <div className="d-flex gap-1 flex-shrink-0">
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => openEditLinkModal(section, link)}
                              >
                                <FaEdit />
                              </button>

                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => {
                                  if (window.confirm(`Are you sure you want to delete link "${link.text}"?`)) {
                                    handleRemoveFooterLink(section._id, link._id);
                                  }
                                }}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      {(!section.links || section.links.length === 0) && (
                        <div className="p-3 text-center text-muted">
                          <small>No links added yet</small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  </div>
);



  // Preview Modal Component
  const PreviewModal = () => {
    if (!selectedItem) return null;

    const renderPreview = () => {
      let content = selectedItem.body || selectedItem.content;
      const sampleData = {
        username: 'John Doe',
        siteName: 'PayEarth',
        orderNumber: 'ORD-12345',
        projectName: 'Website Development',
        amount: '$500.00',
        loginUrl: 'https://payearth.com/login'
      };

      Object.entries(sampleData).forEach(([key, value]) => {
        content = content?.replace(new RegExp(`{{${key}}}`, 'g'), value);
      });

      return content;
    };

    return (
      <Modal
        show={showPreviewModal}
        onHide={() => setShowPreviewModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedItem.name ? `Email Preview: ${selectedItem.name}` : `Preview: ${selectedItem.title}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem.subject && (
            <div className="mb-3">
              <label className="form-label fw-bold">Subject:</label>
              <div className="p-2 bg-light rounded">{selectedItem.subject}</div>
            </div>
          )}
          <div>
            <label className="form-label fw-bold">
              {selectedItem.body ? 'Email Body:' : 'Content:'}
            </label>
            <div
              className="p-3 bg-light rounded border"
              style={{minHeight: '200px'}}
              dangerouslySetInnerHTML={{ __html: renderPreview() }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setShowPreviewModal(false)}
          >
            Close
          </button>
          {selectedItem.body && (
            <button type="button" className="btn custom_btn btn_yellow">
              <FaPaperPlane className="me-1" />
              Send Test Email
            </button>
          )}
        </Modal.Footer>
      </Modal>
    );
  };

  // Delete Confirmation Modal
  const DeleteModal = () => (
    <Modal
      show={showDeleteModal}
      onHide={() => setShowDeleteModal(false)}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <FaTrash className="text-danger mb-3" size={48} />
          <h5>Are you sure?</h5>
          <p className="text-muted">
            This action cannot be undone. This will permanently delete the{' '}
            <strong>{selectedItem?.title || selectedItem?.name}</strong>.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setShowDeleteModal(false)}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={handleDeleteItem}
        >
          <FaTrash className="me-1" />
          Delete
        </button>
      </Modal.Footer>
    </Modal>
  );

const FooterSectionModal = () => (
  <Modal
    show={showFooterModal}
    onHide={() => {
      setShowFooterModal(false);
      setEditingFooterSection(null);
    }}
    size="lg"
    centered
  >
    <Modal.Header closeButton>
      <Modal.Title>
        <FaBullhorn className="me-2" />
        {editingFooterSection?.id ? 'Edit Footer Section' : 'Create Footer Section'}
      </Modal.Title>
    </Modal.Header>
    <Formik
      initialValues={{
        name: editingFooterSection?.name || '',
        description: editingFooterSection?.description || '',
        order: editingFooterSection?.order || (footerSections.length + 1),
        displayOnPages: Array.isArray(editingFooterSection?.displayOnPages)
          ? editingFooterSection.displayOnPages
          : ['all'],
        cssClass: editingFooterSection?.cssClass || '',
        htmlId: editingFooterSection?.htmlId || '',
        active: editingFooterSection?.active !== undefined ? editingFooterSection.active : true,
        isSocialMedia: editingFooterSection?.isSocialMedia !== undefined ? editingFooterSection.isSocialMedia : false
      }}
      validationSchema={footerSectionValidationSchema}
      onSubmit={handleSaveFooterSection}
      enableReinitialize={true}
    >
      {({ isSubmitting, values, setFieldValue }) => (
        <Form>
          <Modal.Body>
            <div className="row">
              <div className="col-md-8">
                <div className="mb-3">
                  <label className="form-label">Section Name *</label>
                  <Field
                    name="name"
                    type="text"
                    className="form-control"
                    placeholder="e.g., Quick Links, Legal, Company"
                  />
                  <ErrorMessage name="name" component="div" className="text-danger small mt-1" />
                  <small className="text-muted">Slug will be auto-generated from the name</small>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label className="form-label">Order *</label>
                  <Field
                    name="order"
                    type="number"
                    className="form-control"
                    min="1"
                  />
                  <ErrorMessage name="order" component="div" className="text-danger small mt-1" />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">Description</label>
              <Field
                name="description"
                as="textarea"
                rows={3}
                className="form-control"
                placeholder="Optional description for this section"
              />
              <ErrorMessage name="description" component="div" className="text-danger small mt-1" />
            </div>

            <div className="mb-3">
              <label className="form-label">Display on Pages *</label>
              <div className="row">
                {['all', 'homepage', 'dashboard', 'public', 'authenticated'].map(page => (
                  <div key={page} className="col-md-4 mb-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`page-${page}`}
                        checked={values.displayOnPages.includes(page)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setFieldValue('displayOnPages', [...values.displayOnPages, page]);
                          } else {
                            setFieldValue('displayOnPages', values.displayOnPages.filter(p => p !== page));
                          }
                        }}
                      />
                      <label className="form-check-label" htmlFor={`page-${page}`}>
                        {page.charAt(0).toUpperCase() + page.slice(1)}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              <ErrorMessage name="displayOnPages" component="div" className="text-danger small mt-1" />
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">CSS Class</label>
                  <Field
                    name="cssClass"
                    type="text"
                    className="form-control"
                    placeholder="Optional CSS class"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">HTML ID</label>
                  <Field
                    name="htmlId"
                    type="text"
                    className="form-control"
                    placeholder="Optional HTML ID"
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div className="form-check">
                <Field
                  name="active"
                  type="checkbox"
                  className="form-check-input"
                  id="section-active"
                />
                <label className="form-check-label" htmlFor="section-active">
                  Active Section
                </label>
              </div>
            </div>

            <div className="mb-3">
              <div className="form-check">
                <Field
                  name="isSocialMedia"
                  type="checkbox"
                  className="form-check-input"
                  id="section-social-media"
                />
                <label className="form-check-label" htmlFor="section-social-media">
                  Social Media Section
                </label>
                <small className="d-block text-muted mt-1">
                  Check this if this section contains social media links with icons
                </small>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setShowFooterModal(false);
                setEditingFooterSection(null);
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn custom_btn btn_yellow"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Saving...
                </>
              ) : (
                <>
                  <FaSave className="me-1" />
                  {editingFooterSection?.id ? 'Update Section' : 'Create Section'}
                </>
              )}
            </button>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  </Modal>
);

// Link Modal (for adding/editing links)
const LinkModal = () => {
  const isSocialMedia = currentSectionForLink?.isSocialMedia || false;

  const socialMediaIcons = [
    { value: 'facebook', label: 'Facebook' },
    { value: 'twitter', label: 'Twitter' },
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'instagram', label: 'Instagram' },
    { value: 'youtube', label: 'YouTube' },
    { value: 'pinterest', label: 'Pinterest' },
    { value: 'tiktok', label: 'TikTok' },
    { value: 'github', label: 'GitHub' },
    { value: 'reddit', label: 'Reddit' },
    { value: 'snapchat', label: 'Snapchat' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'telegram', label: 'Telegram' }
  ];

  const linkValidationSchema = Yup.object().shape({
    text: Yup.string()
      .required('Link text is required')
      .max(100, 'Link text cannot exceed 100 characters'),
    url: Yup.string()
      .required('URL is required')
      .test('valid-url', 'Please enter a valid URL', function(value) {
        if (!value) return false;
        const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w\.-]*)*\/?$/;
        const internalPathRegex = /^\/?[\w\-/]+$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mailtoRegex = /^mailto:[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return urlRegex.test(value) || internalPathRegex.test(value) || emailRegex.test(value) || mailtoRegex.test(value);
      }),
    icon: isSocialMedia
      ? Yup.string().required('Please select an icon')
      : Yup.string(),
    target: Yup.string().required('Target is required')
  });

  const handleSubmitLink = async (values, { setSubmitting, resetForm }) => {
    try {
      const linkData = {
        text: values.text,
        url: values.url,
        target: values.target,
        active: true
      };

      if (isSocialMedia && values.icon) {
        linkData.icon = values.icon;
      }

      if (editingLink) {
        // Update existing link
        await handleEditFooterLink(currentSectionForLink._id, editingLink._id, linkData);
      } else {
        // Add new link
        await handleAddFooterLink(currentSectionForLink.id || currentSectionForLink._id, linkData);
      }

      setShowLinkModal(false);
      setEditingLink(null);
      setCurrentSectionForLink(null);
      resetForm();
    } catch (error) {
      console.error('Error saving link:', error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      show={showLinkModal}
      onHide={() => {
        setShowLinkModal(false);
        setEditingLink(null);
        setCurrentSectionForLink(null);
      }}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FaPlus className="me-2" />
          {editingLink ? 'Edit Link' : 'Add Link'}
          {currentSectionForLink && (
            <small className="d-block text-muted mt-1" style={{ fontSize: '0.875rem' }}>
              Section: {currentSectionForLink.name}
              {isSocialMedia && <span className="badge bg-info ms-2">Social Media</span>}
            </small>
          )}
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={{
          text: editingLink?.text || '',
          url: editingLink?.url || '',
          icon: editingLink?.icon || '',
          target: editingLink?.target || (isSocialMedia ? '_blank' : '_self')
        }}
        validationSchema={linkValidationSchema}
        onSubmit={handleSubmitLink}
        enableReinitialize={true}
      >
        {({ isSubmitting, values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              {isSocialMedia && (
                <div className="mb-3">
                  <label className="form-label">Social Media Icon *</label>
                  <Field
                    as="select"
                    name="icon"
                    className="form-control"
                    onChange={(e) => {
                      setFieldValue('icon', e.target.value);
                      // Auto-fill text if empty
                      if (!values.text) {
                        const selectedIcon = socialMediaIcons.find(icon => icon.value === e.target.value);
                        if (selectedIcon) {
                          setFieldValue('text', selectedIcon.label);
                        }
                      }
                    }}
                  >
                    <option value="">Select an icon...</option>
                    {socialMediaIcons.map(icon => (
                      <option key={icon.value} value={icon.value}>
                        {icon.label}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage name="icon" component="div" className="text-danger small mt-1" />
                  {values.icon && (
                    <div className="mt-2">
                      <small className="text-muted">Preview: </small>
                      <i className={`fab fa-${values.icon} ms-2`} style={{ fontSize: '24px' }}></i>
                    </div>
                  )}
                </div>
              )}

              <div className="mb-3">
                <label className="form-label">Link Text *</label>
                <Field
                  name="text"
                  type="text"
                  className="form-control"
                  placeholder={isSocialMedia ? "e.g., Facebook, Twitter" : "e.g., About Us, Contact"}
                />
                <ErrorMessage name="text" component="div" className="text-danger small mt-1" />
                {isSocialMedia && (
                  <small className="text-muted">Used for accessibility (screen readers)</small>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">URL *</label>
                <Field
                  name="url"
                  type="text"
                  className="form-control"
                  placeholder={isSocialMedia ? "https://facebook.com/yourpage" : "https://example.com or /about"}
                />
                <ErrorMessage name="url" component="div" className="text-danger small mt-1" />
                <small className="text-muted">
                  Enter full URL (https://...) or internal path (/about)
                </small>
              </div>

              <div className="mb-3">
                <label className="form-label">Open Link In *</label>
                <Field as="select" name="target" className="form-control">
                  <option value="_self">Same Window/Tab</option>
                  <option value="_blank">New Window/Tab</option>
                </Field>
                <ErrorMessage name="target" component="div" className="text-danger small mt-1" />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setShowLinkModal(false);
                  setEditingLink(null);
                  setCurrentSectionForLink(null);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn custom_btn btn_yellow"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <FaSave className="me-1" />
                    {editingLink ? 'Update Link' : 'Add Link'}
                  </>
                )}
              </button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

  // Main Render
  return (
    <React.Fragment>
      {loading && <SpinnerLoader />}

      <Helmet>
        <title>Admin - Content Management System - Pay Earth</title>
      </Helmet>

      <div className="seller_dash_wrap admin-cms-page pb-5">
        <div className="container">
          <Header />
          <TabNavigation />

          <div className="admin-cms-content">
            {!loading && (
              <>
                {activeTab === 'banners' && <BannerManagement />}
                {activeTab === 'footer' && <FooterManagement />}
                {activeTab === 'emails' && (
                  <EmailTemplateManagement
                    permissions={permissions}
                    authInfoString={authInfoString}
                  />
                )}
                {activeTab === 'legal' && (
                  <LegalNoticesManagement
                    permissions={permissions}
                    authInfoString={authInfoString}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Modals */}
      <PreviewModal />
      <DeleteModal />
      <FooterSectionModal />
      <LinkModal />
      <ImageModal />
      <EditBannerModal />
      <Footer />
    </React.Fragment>
  );
};

export default AdminCMSInterface;
